import { render, staticRenderFns } from "./DuplicatePostSelectionModal.vue?vue&type=template&id=89a312c6&"
import script from "./DuplicatePostSelectionModal.vue?vue&type=script&lang=js&"
export * from "./DuplicatePostSelectionModal.vue?vue&type=script&lang=js&"
import style0 from "./DuplicatePostSelectionModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/uat.workflow.dashtogo.com/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('89a312c6')) {
      api.createRecord('89a312c6', component.options)
    } else {
      api.reload('89a312c6', component.options)
    }
    module.hot.accept("./DuplicatePostSelectionModal.vue?vue&type=template&id=89a312c6&", function () {
      api.rerender('89a312c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/duplication/DuplicatePostSelectionModal.vue"
export default component.exports